<script setup lang="ts">
/** Appendix C 공통 — Senior Management 인적사항 표. */
import BoAppendixDocVarField from '../BoAppendixDocVarField.vue';

const props = withDefaults(defineProps<{ keyPrefix?: string }>(), { keyPrefix: '' });
function k(base: string) { return `${props.keyPrefix || ''}${base}`; }
</script>

<template>
  <table class="cdd-tbl bo-part-tbl">
    <thead>
      <tr>
        <th class="col-no">NO</th>
        <th>DETAILS OF THE SENIOR MANAGEMENT IN PLACE OF BENEFICIAL OWNER</th>
      </tr>
    </thead>
    <tbody>
      <tr><td class="cdd-lcell">1</td><td>Full name: <BoAppendixDocVarField :field-key="k('sm_full_name')" /></td></tr>
      <tr><td class="cdd-lcell">2</td><td>Office address: <BoAppendixDocVarField :field-key="k('sm_office_address')" /></td></tr>
      <tr><td class="cdd-lcell">3</td><td>Email address: <BoAppendixDocVarField :field-key="k('sm_email')" /></td></tr>
      <tr><td class="cdd-lcell">4</td><td>Address of usual place of residence: <BoAppendixDocVarField :field-key="k('sm_residential_address')" /></td></tr>
      <tr><td class="cdd-lcell">5</td><td>Phone number: <BoAppendixDocVarField :field-key="k('sm_phone')" /></td></tr>
      <tr><td class="cdd-lcell">6</td><td>Nationality: <BoAppendixDocVarField :field-key="k('sm_nationality')" /></td></tr>
      <tr><td class="cdd-lcell">7</td><td>Date of Birth: <BoAppendixDocVarField :field-key="k('sm_dob')" /></td></tr>
      <tr><td class="cdd-lcell">8</td><td>Race: <BoAppendixDocVarField :field-key="k('sm_race')" /></td></tr>
      <tr><td class="cdd-lcell">9</td><td>Gender: <BoAppendixDocVarField :field-key="k('sm_gender')" /></td></tr>
      <tr><td class="cdd-lcell">10</td><td>NRIC/Passport No.: <BoAppendixDocVarField :field-key="k('sm_id_no')" /></td></tr>
      <tr><td class="cdd-lcell">11</td><td>To state position in the company: <BoAppendixDocVarField :field-key="k('sm_position')" /></td></tr>
      <tr><td class="cdd-lcell">12</td><td>The date of appointment to the position: <BoAppendixDocVarField :field-key="k('sm_appointment_date')" /></td></tr>
    </tbody>
  </table>
</template>

<style scoped>
.bo-part-tbl { table-layout: fixed; width: 100%; }
.bo-part-tbl .col-no { width: 36px; }
.bo-part-tbl td, .bo-part-tbl th { word-break: break-word; overflow-wrap: anywhere; }
.bo-part-tbl .cdd-lcell { width: 36px; text-align: center; }
</style>
